import { ChevronDown } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1(P2):样式化下拉——统一箭头/高度/focus 橙环,收编 22 处裸 select。
 * Select=低阶(原生 select 包装);LabeledSelect=筛选 pill 形态(白底细边全圆角,label: 内嵌)。 */
export const Select = React.forwardRef<
	HTMLSelectElement,
	React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, children, ...props }, ref) => (
	<span className={cn("relative inline-flex items-center", className)}>
		<select
			ref={ref}
			className="h-8 w-full cursor-pointer appearance-none rounded-full border border-surface-border bg-surface-card pl-3 pr-7 text-xs text-text-primary transition-colors duration-150 hover:bg-surface-subtle focus:outline-none focus:ring-2 focus:ring-state-focus disabled:cursor-not-allowed disabled:opacity-50"
			{...props}
		>
			{children}
		</select>
		<ChevronDown className="pointer-events-none absolute right-2 h-3.5 w-3.5 text-text-muted" />
	</span>
));
Select.displayName = "Select";

/** 筛选工具条用:一颗白底细边全圆角 pill,「label: 值 ∨」(Intercom 筛选 pill 形态)。 */
export function LabeledSelect({
	label,
	value,
	onChange,
	options,
	className,
}: {
	label: string;
	value: string;
	onChange: (v: string) => void;
	options: Array<{ value: string; label: string }>;
	className?: string;
}) {
	return (
		<label
			className={cn(
				"relative inline-flex h-8 cursor-pointer items-center gap-1 rounded-full border border-surface-border bg-surface-card pl-3 pr-7 text-xs transition-colors duration-150 hover:bg-surface-subtle focus-within:ring-2 focus-within:ring-state-focus",
				className,
			)}
		>
			<span className="shrink-0 text-text-muted">{label}</span>
			<select
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className="cursor-pointer appearance-none bg-transparent pr-1 font-medium text-text-primary focus:outline-none"
			>
				{options.map((o) => (
					<option key={o.value} value={o.value}>
						{o.label}
					</option>
				))}
			</select>
			<ChevronDown className="pointer-events-none absolute right-2 h-3.5 w-3.5 text-text-muted" />
		</label>
	);
}
